(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wallpaper-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wallpaper-calculator')) {
    class WallpaperCalculator extends HTMLElement {
      connectedCallback() {
        if (this.dataset.calculatorReady === 'true') {
          return;
        }

        this.dataset.calculatorReady = 'true';

        this.widthInput = this.querySelector('[data-calculator-width]');
        this.heightInput = this.querySelector('[data-calculator-height]');
        this.widthUnit = this.querySelector('[data-calculator-width-unit]');
        this.heightUnit = this.querySelector('[data-calculator-height-unit]');
        this.submitButton = this.querySelector('[data-calculator-submit]');
        this.result = this.querySelector('[data-calculator-result]');
        this.unitInputs = this.querySelectorAll(
          'input[type="radio"][name^="calculator-unit-"]'
        );

        this.unitInputs.forEach((input) => {
          input.addEventListener('change', () => this.updateUnitLabels());
        });

        this.submitButton.addEventListener('click', () => this.calculate());

        this.widthInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.calculate();
          }
        });

        this.heightInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.calculate();
          }
        });

        this.restoreState();
        this.updateUnitLabels();
      }

      get selectedUnit() {
        return (
          this.querySelector(
            'input[type="radio"][name^="calculator-unit-"]:checked'
          )?.value || 'inches'
        );
      }

      get productRoot() {
        return (
          this.closest('product-info') ||
          this.closest('[data-product-id]') ||
          document
        );
      }

      get storageKey() {
        return (
          this.dataset.storageKey ||
          `hds-wallpaper-calculator-${window.location.pathname}`
        );
      }

      updateUnitLabels() {
        const isCentimeters = this.selectedUnit === 'centimeters';
        const unitLabel = isCentimeters ? 'cm' : 'in';

        this.widthUnit.textContent = unitLabel;
        this.heightUnit.textContent = unitLabel;

        this.widthInput.placeholder = isCentimeters ? 'e.g. 305' : 'e.g. 120';
        this.heightInput.placeholder = isCentimeters ? 'e.g. 244' : 'e.g. 96';

        this.hideResult();
      }

      calculate() {
        const width = Number.parseFloat(this.widthInput.value);
        const height = Number.parseFloat(this.heightInput.value);

        if (
          !Number.isFinite(width) ||
          !Number.isFinite(height) ||
          width <= 0 ||
          height <= 0
        ) {
          this.showError(
            'Please enter a valid wall width and wall height greater than zero.'
          );
          return;
        }

        const conversionFactor =
          this.selectedUnit === 'centimeters' ? 2.54 : 1;

        const widthInches = width / conversionFactor;
        const heightInches = height / conversionFactor;

        const panelQuantity = Math.ceil(widthInches / 19);
        const panelHeightFeet = Math.ceil(heightInches / 24) * 2;

        if (panelHeightFeet > 18) {
          this.showError(
            'Your wall is taller than our maximum 18 ft panel height. Please contact us before ordering so we can help with a custom solution.'
          );
          return;
        }

        const panelSizeValue =
          `${panelHeightFeet} ft (h) x 19 in (w)`;

        const panelInput = this.findPanelSizeInput(panelSizeValue);

        if (!panelInput) {
          this.showError(
            `The recommended panel size “${panelSizeValue}” could not be found on this product. Please select the closest suitable panel size manually.`
          );
          return;
        }

        if (panelInput.dataset.optionAvailable === 'false') {
          this.showError(
            `The recommended panel size “${panelSizeValue}” is currently unavailable. Please contact us for assistance.`
          );
          return;
        }

        this.saveState({
          unit: this.selectedUnit,
          width: this.widthInput.value,
          height: this.heightInput.value,
          panelSize: panelSizeValue,
          quantity: panelQuantity
        });

        this.showSuccess(panelSizeValue, panelQuantity);

        if (!panelInput.checked) {
          panelInput.click();
        }

        this.setQuantity(panelQuantity);

        window.setTimeout(() => {
          this.setQuantity(panelQuantity);
        }, 350);

        window.setTimeout(() => {
          this.setQuantity(panelQuantity);
        }, 900);
      }

      findPanelSizeInput(panelSizeValue) {
        const inputs = Array.from(
          this.productRoot.querySelectorAll(
            'input[type="radio"][data-option-name="Panel Size"]'
          )
        );

        return inputs.find(
          (input) => input.value.trim() === panelSizeValue
        );
      }

      setQuantity(quantity) {
        const currentRoot =
          this.closest('product-info') ||
          document.querySelector('product-info') ||
          document;

        const quantityInput = currentRoot.querySelector(
          'quantity-selector-component input[name="quantity"], input[name="quantity"]'
        );

        if (!quantityInput) {
          return;
        }

        const valueSetter = Object.getOwnPropertyDescriptor(
          HTMLInputElement.prototype,
          'value'
        )?.set;

        if (valueSetter) {
          valueSetter.call(quantityInput, String(quantity));
        } else {
          quantityInput.value = String(quantity);
        }

        quantityInput.dispatchEvent(
          new Event('input', { bubbles: true })
        );

        quantityInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );

        quantityInput.blur();
      }

      showSuccess(panelSize, quantity) {
        this.result.classList.remove(
          'hds-wallpaper-calculator__result--error'
        );

        this.result.innerHTML = `
          <strong class="hds-wallpaper-calculator__result-title">
            Your wallpaper recommendation
          </strong>

          <div class="hds-wallpaper-calculator__result-row">
            <span>Recommended panel size</span>
            <strong>${panelSize}</strong>
          </div>

          <div class="hds-wallpaper-calculator__result-row">
            <span>Panels required</span>
            <strong>${quantity}</strong>
          </div>

          <p class="hds-wallpaper-calculator__result-note">
            We have automatically selected the recommended panel size and
            updated the quantity above. Please check your measurements once
            more before adding the wallpaper to your cart.
          </p>
        `;

        this.result.hidden = false;
      }

      showError(message) {
        this.result.classList.add(
          'hds-wallpaper-calculator__result--error'
        );

        this.result.innerHTML = `
          <strong class="hds-wallpaper-calculator__result-title">
            Please check your measurements
          </strong>
          <span>${message}</span>
        `;

        this.result.hidden = false;
      }

      hideResult() {
        this.result.hidden = true;
        this.result.innerHTML = '';
      }

      saveState(state) {
        try {
          window.sessionStorage.setItem(
            this.storageKey,
            JSON.stringify(state)
          );
        } catch (error) {
          // The calculator still works when storage is unavailable.
        }
      }

      restoreState() {
        try {
          const storedState = window.sessionStorage.getItem(
            this.storageKey
          );

          if (!storedState) {
            return;
          }

          const state = JSON.parse(storedState);

          const unitInput = this.querySelector(
            `input[type="radio"][value="${state.unit}"]`
          );

          if (unitInput) {
            unitInput.checked = true;
          }

          if (state.width) {
            this.widthInput.value = state.width;
          }

          if (state.height) {
            this.heightInput.value = state.height;
          }

          if (state.panelSize && state.quantity) {
            this.showSuccess(state.panelSize, state.quantity);
          }
        } catch (error) {
          // Ignore invalid or unavailable stored calculator data.
        }
      }
    }

    customElements.define(
      'wallpaper-calculator',
      WallpaperCalculator
    );
  }
  } catch(e) { console.error(e); }
})();

})();
